import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'AI Assets by Platform',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: '',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'AI-Enabled Assets',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'ChatGPT',
                                  y: {
                                    '#': {
                                      '@': 'chatgptAssets',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Copilot',
                                  y: {
                                    '#': {
                                      '@': 'copilotAssets',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bedrock',
                                  y: {
                                    '#': {
                                      '@': 'bedrockAssets',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    bedrockAssets: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!ai_enabled',
              },
              true,
            ],
          },
          {
            '=': [
              {
                '@.': '!ai_platform',
              },
              'Bedrock',
            ],
          },
        ],
      },
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!id',
      },
    },
    chatgptAssets: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!ai_enabled',
              },
              true,
            ],
          },
          {
            '=': [
              {
                '@.': '!ai_platform',
              },
              'ChatGPT',
            ],
          },
        ],
      },
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!id',
      },
    },
    copilotAssets: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!ai_enabled',
              },
              true,
            ],
          },
          {
            '=': [
              {
                '@.': '!ai_platform',
              },
              'Copilot',
            ],
          },
        ],
      },
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!id',
      },
    },
  },
}
